// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f2600aeb","229":"f2125326","242":"db41c536","453":"5d6f1bf2","489":"d30d1f4b","541":"5f2beed3","688":"30935e71","699":"bd0be108","822":"b8106d2c"}[chunkId] + ".chunk.js";
};